<template>
  <b-table :fields="table_fields" :items="table_items" />
</template>

<i18n>
{
  "en": {
    "specific_columns": "Specific columns"

  },
  "fr": {
    "specific_columns": "Colonnes spécifiques"
  }
}
</i18n>

<script>
import _ from 'lodash'
import { get_columnstore_listing_from_poid } from '@/api/subscriptions.js'
import {
  extended_dict_getValue,
  extended_dict_invert,
  dict_from_frozendict,
} from '@/utils.js'

import {
  subscription_mixin,
  summary_mixin,
  metavariables_tracking_info_mixin,
} from '@/components/mixin.js'
import TextFitter from './text_fitter.vue'

// *****************************************************************************

export default {
  name: 'SummaryDispatch',
  components: { TextFitter },
  mixins: [
    subscription_mixin,
    summary_mixin,
    metavariables_tracking_info_mixin,
  ],
  props: ['project_id', 'brick_id', 'metavariables_dicts_poids'],
  data() {
    return {
      tables_columns: [],
    }
  },
  computed: {
    metavariables_dicts() {
      const dict = extended_dict_invert(
        this.cur_brick.last_poids_build_cache || {}
      )
      return _.map(this.metavariables_dicts_poids, poid =>
        dict_from_frozendict(extended_dict_getValue(dict, poid))
      )
    },
    table_fields() {
      return [
        { key: 'metavariables_dict', label: this.$t('metavariables') },
        { key: 'unique_cols', label: this.$t('specific_columns') },
      ]
    },
    table_items() {
      let columns_intersection = _.intersection(...this.tables_columns)
      let specific_columns = _.map(this.tables_columns, elt =>
        _.difference(elt, columns_intersection)
      )
      let res = _.map(specific_columns, (elt, index) => {
        return {
          metavariables_dict: this.metavariables_dicts[index],
          unique_cols: elt,
        }
      })

      return res
    },
  },
  watch: {
    tracking_infos: {
      immediate: true,
      async handler(nv) {
        let tables_columns = _.map(nv, elt =>
          get_columnstore_listing_from_poid(
            this.project_id,
            (elt || {}).parent_table_poid
          )
        )
        tables_columns = await Promise.all(tables_columns)
        tables_columns = _.map(tables_columns, elt => elt.pipe_object)
        this.tables_columns = tables_columns
      },
    },
  },
}
</script>
